
<div id="{{modalId}}" tabindex="-1" class="dds__modal dds__fade  modal-backdrop" role="dialog" aria-hidden="true"> 
    <div class="dds__modal-dialog" role="document">
        
        <div class="dds__modal-content" style="height: fit-content; width: fit-content;">
            <div class="dds__modal-header">
                <h3 class="dds__modal-title" id="{{modalTitleId}}">
                    <ng-content select="[modal-title]"></ng-content>
                </h3>
            </div>
            <ng-content select="[modal-close]"></ng-content>
            <div class="dds__modal-body">
                <ng-content select="[modal-body]"></ng-content>
            </div> 
            <div class="dds__modal-footer" style="align-content: center;">
                <ng-content select="[modal-footer]"></ng-content>
            </div>
    </div>
</div>
<a #triggerContainer>
    <ng-content select="[modal-trigger]"></ng-content>
</a>
